import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import ChatLogsLayer from '../components/ChatLogsLayer'

function ChatLogsPage() {
  return (
    <>
    {/* Master layout */}
    <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Chat logs"/>

        {/* Chatlogs layer */}
        <ChatLogsLayer/>
    </MasterLayout>
    </>
  )
}

export default ChatLogsPage